'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Paper/Paper.tsx
import { twMerge } from "tailwind-merge";

// src/Paper/Paper.classes.tsx
var SURFACE_CLASSES = {
  default: "bg-paper",
  "level-1": "bg-paper-level-1",
  "level-2": "bg-paper-level-2",
  "level-3": "bg-paper-level-3"
};
var SIZE_CLASSES = {
  L: "p-L",
  M: "p-M",
  S: "p-S",
  XS: "p-XS"
};
var BORDER_CLASSES = {
  default: "border border-paper",
  "level-1": "border border-paper-level-1",
  "level-2": "border border-paper-level-2",
  "level-3": "border border-paper-level-3"
};

// src/Paper/Paper.tsx
import { jsx } from "react/jsx-runtime";
var Paper = (_a) => {
  var _b = _a, {
    surface = "default",
    size = "M",
    border = true,
    rounded = true,
    as: Component = "div",
    className,
    children
  } = _b, props = __objRest(_b, [
    "surface",
    "size",
    "border",
    "rounded",
    "as",
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx(
    Component,
    __spreadProps(__spreadValues({
      className: twMerge(
        SURFACE_CLASSES[surface],
        SIZE_CLASSES[size],
        border ? BORDER_CLASSES[surface] : "",
        rounded ? "rounded-S" : "",
        className
      )
    }, props), {
      children
    })
  );
};
var Paper_default = Paper;

export {
  Paper_default
};
//# sourceMappingURL=chunk-GNKSIG7J.mjs.map